import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ minHeight: "100vh", padding: "24px", textAlign: "left" }}>
      <div style={{ maxWidth: "800px", margin: "0 auto", textAlign: "left" }}>
        <h1 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "16px" }}>
          Happenhood Privacy Policy
        </h1>
        <p style={{ marginBottom: "24px" }}>Last Updated: August 18, 2025</p>

        <p style={{ marginBottom: "16px" }}>
          At happenhood, we respect your privacy and are committed to being transparent
          about why we ask for certain permissions such as access to your camera
          and microphone.
        </p>

        <h2 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "8px" }}>
          Why we use Camera and Microphone
        </h2>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "24px" }}>
          <li>To enable live streaming so you can share video and audio in real time when hosting or joining events.</li>
          <li>To allow participation if a host invites you on stage, requiring temporary camera and microphone access.</li>
          <li>To support voice features like sending voice notes or joining audio-only chats (microphone only while speaking).</li>
          <li>To test your devices before going live — this data is never stored.</li>
          <li>Viewers can watch streams without enabling camera or microphone.</li>
        </ul>

        <h2 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "8px" }}>
          How we handle your data
        </h2>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "24px" }}>
          <li>Your camera and microphone are only active when you choose to enable them.</li>
          <li>We never turn them on without your permission.</li>
          <li>If recording is enabled, you’ll always see a clear indicator.</li>
          <li>Media for live sessions is processed in real time and not stored unless you choose to record.</li>
        </ul>

        <h2 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "8px" }}>
          Your Controls
        </h2>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "24px" }}>
          <li>You can deny or revoke camera/mic access anytime in your device settings.</li>
          <li>You can mute or disable video during a session.</li>
          <li>You can watch streams without enabling camera or microphone.</li>
        </ul>

        <h2 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "8px" }}>
          Contact Us
        </h2>
        <p>
          If you have any questions about this policy, please contact us at:{" "}
          <strong>privacy@happenhood.app</strong>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
